import { createAsyncThunk } from "@reduxjs/toolkit";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";

import OptionHeaders from "../options";
const { token, baseUrl } = OptionHeaders();
const TIMESHEET_SHOW = "timesheet/showTimesheet";
const TIMESHEET_SUMMARY_SHOW = "timesheet/showTimesheetSummary";
const TIMESHEET_APPROVAL_SHOW = "timesheet/showTimesheetApproval";
const TIMESHEET_MANAGER_SHOW = "timesheet/showTimesheetManager";

export const showTimesheet = createAsyncThunk(
  TIMESHEET_SHOW,
  async (thunkAPI) => {
    try {
      const timesheet = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}Timesheet`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
        expand: ["Employee($expand=Department,Position)"],
      });
      return timesheet;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const showTimesheetSummaryData = createAsyncThunk(
  TIMESHEET_SUMMARY_SHOW,
  async (thunkAPI) => {
    try {
      const timesheet = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}TimesheetSummary`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
        expand: ["Employee($expand=Department,Position)"],
      });
      return timesheet;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const showTimesheetManager = createAsyncThunk(
  TIMESHEET_MANAGER_SHOW,
  async (thunkAPI) => {
    try {
      const timesheet = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}TimesheetManager`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
        expand: ["Employee($expand=Department,Position)"],
      });
      return timesheet;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const showTimesheetApproval = createAsyncThunk(
  TIMESHEET_APPROVAL_SHOW,
  async (thunkAPI) => {
    try {
      const timesheet = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}TimesheetApproval`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
        expand: ["Employee($expand=Department,Position)"],
      });
      return timesheet;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
